import React from "react";

interface MinpakuGuideNumberProps {
  trackNumber: number;
  className?: string;
  color?: string;
}

/**
 * ヘッドフォンアイコン付きガイド番号コンポーネント
 * SVGを使用して番号部分を動的に表示
 */
export const MinpakuGuideNumber: React.FC<MinpakuGuideNumberProps> = ({
  trackNumber,
  className,
  color = "#333333",
}) => {
  return (
    <svg
      viewBox="0 0 200 200"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 白色背景 */}
      <rect width="200" height="200" fill="#FFFFFF" />

      {/* ヘッドフォンアイコン部分 */}
      <g
        transform="translate(0,200) scale(0.1,-0.1)"
        fill={color}
        stroke="none"
      >
        <path d="M913 1659 c-344 -40 -613 -316 -649 -665 -5 -50 -11 -64 -29 -74 -48
-25 -55 -56 -55 -230 0 -178 7 -208 60 -235 43 -22 112 -19 144 6 50 39 56 65
56 231 0 134 -3 157 -20 185 -10 17 -28 37 -39 43 -26 13 -27 57 -6 147 54
229 228 410 460 479 92 27 249 25 345 -4 117 -37 187 -79 276 -167 64 -64 90
-97 123 -165 37 -77 70 -191 71 -246 0 -12 -18 -40 -40 -62 l-40 -40 0 -166
c0 -185 7 -214 60 -241 43 -22 112 -19 144 6 50 39 56 65 56 229 0 163 -7 191
-55 226 -21 16 -27 31 -35 94 -32 253 -181 465 -409 580 -118 59 -276 85 -418
69z" />
      </g>

      {/* 番号部分 */}
      <text
        x="100"
        y="135"
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
        fontWeight="bold"
        fontSize="80"
        fill={color}
      >
        {trackNumber}
      </text>
    </svg>
  );
};
